// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { cronos as _cronos } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the cronos chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 25
 * Chain Name: Cronos Mainnet
 * Default Block Explorer: https://explorer.cronos.org
 * Default RPC URL: https://evm.cronos.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { cronos } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: cronos,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const cronos = createCommon({
	..._cronos,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
